import { Component, Watch } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import {
  exportMaterial,
  importMaterial,
  exportMaterialTemplate
} from '@/api/api'
import { MaterialServiceProxy, MaterialTypeServiceProxy, MaterialFieldSettingServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import { cloneDeep } from 'lodash'
import getScrollY from '@/utils/scroll'

const msp = new MaterialServiceProxy()
const mtsp = new MaterialTypeServiceProxy()
const crsp = new CodeRuleServiceProxy()
const mfssp = new MaterialFieldSettingServiceProxy()

@Component
export default class MaterialInfo extends Template {
  // 物料信息
  name = 'MaterialInfo'
  options = {
    retrieve: msp.getPageMaterial.bind(msp),
    search: msp.getMaterial.bind(msp),
    create: msp.createMaterial.bind(msp),
    update: msp.updateMaterial.bind(msp),
    delete: msp.deleteMaterial.bind(msp)
  }
  acl = {
    create: 'page_business_create_material',
    update: 'page_business_edit_material',
    delete: 'page_business_delete_material'
  }
  ie = true
  keywords = ''
  materialList = [] // 物料列表
  typeId = '' // 当前物料类型id
  typeCodeId = ''
  typeName = '' //当前物料类型名称
  waitGetData = true
  materialTypeList = []
  importFilename = '物料信息.xlsx'
  exportFilename = '物料信息.xlsx'
  materialCodeList = []
  disabled = false
  property = null
  // scroll = { x: 1200 }

  downloadFn = exportMaterialTemplate
  importFn = importMaterial
  exportFn = this.handleExport
  fieldSettingDialogVisible = false
  extendFieldList = []
  updateExtendFieldList: any = [
    { code: 'extend1', name: '自定义字段1', isDisplay: 0 },
    { code: 'extend2', name: '自定义字段2', isDisplay: 0 },
    { code: 'extend3', name: '自定义字段3', isDisplay: 0 },
    { code: 'extend4', name: '自定义字段4', isDisplay: 0 },
    { code: 'extend5', name: '自定义字段5', isDisplay: 0 }
  ]

  scroll: any = {};

  get propertyList() {
    let temp = [
      { label: 'page_business_material_property_raw_material', value: 1 },
      { label: 'page_business_material_property_partially_prepared_products', value: 2 },
      { label: 'page_business_material_property_finished_product', value: 3 },
      { label: 'page_business_material_property_spare_parts', value: 4 },
      { label: 'page_business_material_property_accessories', value: 5 },
      { label: 'page_business_material_property_other', value: 9 }
    ]
    return temp.map(item => ({ label: this.$t(item.label), value: item.value }))
  }

  get lang() {
    return {
      create: this.$t('page_business_create_material'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      delete: this.$t('page_business_delete_material')
    }
  }

  @Watch('typeId')
  handleTypeIdChange(val) {
    this.dataSource = []
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.getData()
  }

  created() {
    this.getMaterialTypeList()
    this.getFieldSetting()
    let clientWith = document.body.clientWidth
    if (clientWith < 1713) {
      this.scroll['x'] = 1200
    } else {
      this.scroll['x'] = 0
    }
    this.getCodeRules()
    this.property = this.propertyList[0].value
  }

  async createData() {
    const data: any = await this._form_2.manualSubmit();
    this.typeCodeId = data.typeId
    let res = await mtsp.getMaterialTypeList()
    let arr = res
    arr.map(item => {
      if(this.typeCodeId === item.id) {
        this.typeName =item.name
        data.typeName = this.typeName
      }
    })
    this.saveLoading = true;
    const fetchFn = this.options.create;
    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_create_success'))
      this.disabled = false
      this.showDialog = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }

  async getMaterialTypeList() {
    let res = await mtsp.getMaterialTypeList()
    this.materialTypeList = res.map(item => ({ label: item.name, value: item.id }))
    if (this.materialTypeList.length) {
      this.typeId = this.materialTypeList[0].value
    }

    // console.log('materialTypeList:', this.materialTypeList)
  }

  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    if (reload) current = 1
    const fetchFn = this.options.retrieve

    const { records, total: t, size: s, current: c } = await fetchFn(
      current,
      keyWords,
      this.property,
      size,
      this.typeId
    )

    this.dataSource = records

    let dataLength = records.length;
    let copy = JSON.parse(JSON.stringify(records));
    let needPush = 0;
    if(dataLength < 30) {
      needPush = 30 - dataLength;
      for(var k=0; k<needPush; k++) {
        let obj = {
          // id: 'none'
        }
        copy.push(obj)
      }
    }
    this.dataSource = JSON.parse(JSON.stringify(copy));
    
    this.scroll['y'] = getScrollY('material-info-console',this.dataSource.length)

    this.filters = {
      total: Number(t),
      size: Number(s),
      current: Number(c)
    }
  }

  async handleExport() {
    let params = {
      exportSelected: !!(this.selectedIds.length),
      keyWord: this.keywords,
      property: this.property,
      selectedRecords: this.selectedIds,
      tenantId: '',
      typeId: this.typeId
    }
    return await exportMaterial(params)
  }
  async getCodeRules(){
    const res = await crsp.list('MaterialObject')
    let arr = []
    arr = res
    arr.map(item =>{
      this.materialCodeList.push({
        label: item.name,
        value:item.id
      })
    })

  }
  async handleChang(val) {
    if(val) {
      this.disabled = true
      await this._form_2.form.setFieldsValue({['code']:''})
    }else {
      this.disabled = false
    }

  }
  render() {
    return this.customRender()
  }

  extraHeaderAction() {
    return [
      <import-button
        filename={this.importFilename}
        downloadFn={this.downloadFn}
        importFn={this.importFn}
        refresh={this.refresh}
        newResFlag={true}
        style="margin-left: 8px"
      />,
      <export-button
        simple
        filename={this.exportFilename}
        exportFn={this.exportFn}
        style="margin-left: 8px"
      />
    ]
  }

  renderHeader() {
    return (
      <div
        slot="action"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <a-button
            v-acl={this.acl.create}
            type="primary"
            style={{ marginRight: '8px' }}
            onClick={this.openCreateWindow}
          >
            {this.lang.create}
          </a-button>
          <a-popconfirm
            title={this.$t('page_resource_pool_confirm_delete')}
            onConfirm={this.deleteData}
            okText={this.$t('yes')}
            cancelText={this.$t('no')}
            disabled={this.selectedIds.length < 1}
          >
            <a-button
              v-acl={this.acl.delete}
              type="danger"
              disabled={this.selectedIds.length < 1}
            >
              {this.lang.delete}
            </a-button>
          </a-popconfirm>
          {this.ie ? this.extraHeaderAction() : null}
          <a-button
           style={{ marginLeft: "8px" }}
           disabled={this.selectedIds.length < 1}
           onClick={this.printing}
          >
             {this.$t('page_print_code')}
          </a-button>
          <a-button
            style={{ marginLeft: '8px' }}
            onClick={() => {
              this.fieldSettingDialogVisible = true
            }}
          >
            {this.$t('page_business_field_setting')}
          </a-button>
        </div>
        <div>
          <app-select list={this.materialTypeList} v-model={this.typeId}
                      onChangeSelect={this.handleTypeChange}
                      style="width: 150px;"/>
          <app-select list={this.propertyList} v-model={this.property}
                      onChangeSelect={this.handlePropertyChange}
                      style="width: 150px;"/>
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
            style="width: 180px!important;"
            v-model={this.keywords}
          ></a-input-search>
        </div>
      </div>
    )
  }

  customRender() {
    return (
      <blank-view>
        {this.renderHeader()}
        <div id="material-info-console" style="height:100%">
          {this.renderBody()}
          {this.renderDialog()}
          {this.renderDrawer()}
          {this.renderPrint()}
          {this.renderFieldSettingDialog()}
        </div>
      </blank-view>
    );
  }

  handleTypeChange(value) {
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.typeId = value
  }

  handlePropertyChange(value) {
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.property = value
    this.getData()
  }

  get columns() {
    let extendCols = []
    this.extendFieldList.map(item => {
      if (item.isDisplay === 1) {
        extendCols.push({
          title: item.name,
          dataIndex: item.code,
          width: 100,
          ellipsis: true
        })
      }
    })

    let cols = [
      // { title: this.$t('page_business_material_barcode'), dataIndex: 'barCode', width: 100, ellipsis: true },
      { title: this.$t('page_business_material_code'), dataIndex: 'code', width: 100, ellipsis: true },
      { title: this.$t('page_business_material_name'), dataIndex: 'name', width: 100, ellipsis: true },
      {
        title: this.$t('page_business_material_type'),
        dataIndex: 'typeId',
        width: 100,
        ellipsis: true,
        customRender: (text) => {
          if (text) {
            return this.materialTypeList.find(item => item.value === text).label
          }
        }
        // customRender: (text) => (this.materialTypeList.find(item => item.value === text).label)
      }, {
        title: this.$t('page_business_material_property'),
        dataIndex: 'property',
        width: 100,
        ellipsis: true,
        customRender: (text) => {
          if (text) {
            let item = this.propertyList.find(item => item.value === text)
            if (item && item.hasOwnProperty('label')) {
              let name: any = item.label
              return this.$t(name)
            }
          }
        }
      },
      { title: this.$t('page_business_rated_stock'), dataIndex: 'lowerLimit', width: 100, ellipsis: true },
      { title: this.$t('page_business_safety_stock'), dataIndex: 'upperLimit', width: 100, ellipsis: true },
      {
        title: this.$t('page_business_necessary_to_check'), dataIndex: 'isMustCheck', width: 100, ellipsis: true,
        customRender: (text, record) => {
          if (record.id) {
            return text ? this.$t('page_business_necessary_to_check_true') : this.$t('page_business_necessary_to_check_false')
          }
        }
      },
      { title: this.$t('page_business_unit_of_measurement'), dataIndex: 'unit', width: 100, ellipsis: true },
      { title: this.$t('page_business_material_1'), dataIndex: 'stuff', width: 100, ellipsis: true },
      { title: this.$t('page_business_specifications'), dataIndex: 'standardModel', width: 100, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', width: 100, ellipsis: true },
      ...extendCols
    ]
    this.scroll['x'] = cols.length * 110
    return cols
  }


  get schema() {
    let extendCols = {}
    this.extendFieldList.map(item => {
      if (item.isDisplay === 1) {
        extendCols[item.code] = {
          label: item.name,
          type: 'input',
          props: {
            allowClear: true,
            placeholder: this.$t('page_material_warehousing_p_input'),
          }
        }
      }
    })

    return {
      /* barCode: {
         label: this.$t('page_business_material_barcode'),
         type: 'input',
         props: {
           placeholder: this.$t('page_business_material_barcode'),
           maxLength: 48
         }
       },*/
       codeRuleId: {
        label: this.$t('page_system_coding_rules'),
        type: 'select',
        display:this.showDrawer?"none":"block",
        props: {
          allowClear: true,
          placeholder: this.$t('page_system_select_coding_rule'),
          maxLength: 28,
        },
        rules: [
          {
            message: this.$t('page_system_coding_rules')
          }
        ],
        options:this.materialCodeList,
        on: {
          change: this.handleChang
        },
      },
      code: {
        label: this.$t('page_business_material_code'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_material_code'),
          // maxLength: 48,
          disabled: this.disabled || this.showDrawer
        },
        rules: [
          {
            required: !this.disabled,
            message: this.$t('page_business_enter_material_code')
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      name: {
        label: this.$t('page_business_material_name'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_material_name')
          // maxLength: 48
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_enter_material_name')
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      typeId: {
        label: this.$t('page_business_material_type'),
        type: 'select',
        props: {
          allowClear: true,
          placeholder: this.$t('page_business_select_material_type')
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_select_material_type')
          }
        ],
        options: this.materialTypeList,
        defaultValue: this.typeId
      },
      // 物料属性
      property: {
        label: this.$t('page_business_material_property'),
        type: 'select',
        props: {
          allowClear: true,
          placeholder: this.$t('page_business_select_material_property')
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_select_material_property')
          }
        ],
        options: this.propertyList,
      },
      unit: {
        label: this.$t('page_business_unit_of_measurement'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_unit_of_measurement')
          // maxLength: 48
        },
        rules: [
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      stuff: {
        label: this.$t('page_business_material_1'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_material')
          // maxLength: 48
        },
        rules: [
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      standardModel: {
        label: this.$t('page_business_specifications'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_specifications')
          // maxLength: 48
        },
        rules: [
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      remark: {
        label: this.$t('remark'),
        type: 'input',
        props: {
          placeholder: this.$t('remark_tips')
          // maxLength: 48,
        },
        rules: [
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      lowerLimit: {
        label: this.$t('page_business_rated_stock'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_rated_stock'),
          max: 99999999
        }
      },
      upperLimit: {
        label: this.$t('page_business_safety_stock'),
        type: 'inputNumber',
        props: {
          placeholder: this.$t('page_business_enter_safety_stock'),
          max: 99999999
        }
      },
      isMustCheck: {
        label: this.$t('page_business_necessary_to_check'),
        type: 'radio',
        props: {
          placeholder: this.$t('page_business_necessary_to_check')
        },
        options: [
          {
            label: this.$t('yes'),
            value: 1
          },
          {
            label: this.$t('no'),
            value: 0
          }
        ],
        rules: [
          {
            required: true,
            message: this.$t('page_business_necessary_to_check')
          }
        ]
      },
      ...extendCols

    }
  }

  handleFieldSettingChange(value,type, index) {
    let temp = cloneDeep(this.updateExtendFieldList)
    temp[index][type] = value
    this.updateExtendFieldList = cloneDeep(temp)
  }

  get isDisplayList() {
    return [
      { label: this.$t('yes'), value: 1 },
      { label: this.$t('no'), value: 0 }
    ]
  }

  get fieldSettingColumns() {
    return [
      { title: this.$t('page_resource_pool_field'), dataIndex: 'code', width: 100, ellipsis: true },
      {
        title: this.$t('page_bill_manage_title'), dataIndex: 'name', width: 150, ellipsis: true,
        customRender: (text, record, index) => {
          return (
            <div>
              <a-input type="text" value={text}
                       placeholder={this.$t('page_transport_directory_custom_fields') + (index + 1)}
                       onchange={(e) => this.handleFieldSettingChange(e.target.value, 'name', index)}
                       style="width: 100%;"/>
            </div>
          )
        }
      },
      {
        title: this.$t('page_resource_pool_show'), dataIndex: 'isDisplay', width: 150, ellipsis: true,
        customRender: (text, record, index) => {
          return (
            <div>
              <app-select list={this.isDisplayList} v-model={text}
                          onChangeSelect={(e) => this.handleFieldSettingChange(e, 'isDisplay', index)}
                          style="width: 100%;"/>
            </div>
          )
        }
      }
    ]
  }

  closeDialog() {
    this.fieldSettingDialogVisible = false
  }
  fieldLoading = false
  async saveExtendFields() {
    this.fieldLoading = true
    await mfssp.save(this.updateExtendFieldList)
    this.fieldLoading = false
    this.getFieldSetting()
    this.fieldSettingDialogVisible = false
  }

  async getFieldSetting() {
    this.fieldLoading = true
    this.extendFieldList = await mfssp.get()
    this.updateExtendFieldList = this.extendFieldList.length ? cloneDeep(this.extendFieldList) : this.updateExtendFieldList
    this.fieldLoading = false
  }

  /*字段设置*/
  renderFieldSettingDialog() {
    return (
      <a-modal
        onCancel={this.closeDialog}
        title={this.$t('page_business_custom_field_setting')}
        visible={this.fieldSettingDialogVisible}
        destroyOnClose={true}
        maskClosable={false}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={this.closeDialog}
          >
            {this.$t("cancel")}
          </a-button>
          <a-button type="primary" onClick={this.saveExtendFields}  loading={this.fieldLoading}>
            {this.$t("page_personal_baseinfo_save")}
          </a-button>
        </div>
        <ml-table
          size="small"
          rowKey="code"
          defaultExpandAllRows={true}
          canChangeColWidth={false}
          loading={this.loading}
          dataSource={this.updateExtendFieldList}
          columns={this.fieldSettingColumns}
          scroll={{}}
        />
      </a-modal>
    );
  }
}
